/* eslint-disable default-param-last */import intersection from 'lodash/intersection';

/**
 * Returns the best match for the user's locale.
 *
 * @param Array   preferedLocales   the locales requested
 * @param Array   availableLocales  locales available for the application
 * @param String  defaultLocale     the fallback locale
 *
 * @return String
 */
var negociateLocale = function negociateLocale() {
  var preferedLocales = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var availableLocales = arguments.length > 1 ? arguments[1] : undefined;
  var defaultLocale = arguments.length > 2 ? arguments[2] : undefined;
  var validLanguages = intersection(preferedLocales.filter(Boolean), availableLocales);
  if (validLanguages.length) {
    return validLanguages[0];
  }
  return defaultLocale;
};
export default negociateLocale;